import styles from './SimCarrierDistribution.module.css';

function SimCarrierDistribution({ carriers, title }) {
  return (
    <div className={styles.card}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.bar}>
        {carriers.map((c) => (
          <div
            key={c.name}
            className={styles.segment}
            style={{ width: `${c.pct}%`, background: c.color }}
          />
        ))}
      </div>
      <div className={styles.stats}>
        {carriers.map((c) => (
          <div key={c.name} className={styles.item}>
            <div className={styles.name}>
              <span className={styles.dot} style={{ background: c.color }} />
              {c.name}
            </div>
            <div className={styles.value}>
              {(c.value ?? 0).toLocaleString()}
              <span className={styles.pct}>{c.pct}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SimCarrierDistribution;
